import React from 'react'
import { Button } from '../ui/Button'
import { useI18n } from '../../i18n'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'

interface Props {
  standardCode: string
  isActive?: boolean
  workflowStage?: string
  onActivate: () => void
  loading?: boolean
}

export default function StandardActivationWizard({
  standardCode,
  isActive,
  workflowStage,
  onActivate,
  loading,
}: Props) {
  const { t } = useI18n()
  if (isActive && workflowStage && workflowStage !== 'NOT_ACTIVATED') return null

  return (
    <GovernanceListingSection
      title={`${t('complianceWorkflow.operationalCertification', 'Operational Certification')} — ${standardCode}`}
      description={t(
        'complianceWorkflow.activateHint',
        'Activate this standard to launch the operational compliance workflow.',
      )}
      toolbar={
        <Button type="button" size="small" color="brand" disabled={loading} onClick={onActivate}>
          {t('complianceWorkflow.activateStandard', 'Activate standard')}
        </Button>
      }
    >
      <p className="text-xs text-slate-500 m-0">
        {t('complianceWorkflow.activateBody', 'Activation enables scope definition, applicability discovery, and readiness tracking for this standard.')}
      </p>
    </GovernanceListingSection>
  )
}
